import { Reveal, Overline } from "./Reveal";

const CATS = [
  "Caisse", "Logiciel HACCP", "Matériel de cuisine", "Téléphonie", "Paiement",
  "Assurance", "Mobilier", "Nettoyage", "Énergie", "Communication",
  "Fournitures", "Équipement CHR",
];

const Pill = ({ label }) => (
  <span
    data-testid="deposit-category-item"
    className="mx-2 inline-flex shrink-0 items-center gap-2 rounded-full border border-black/10 bg-white px-6 py-3 text-base font-bold text-ink shadow-sm"
  >
    <span className="h-2 w-2 rounded-full bg-brand" />
    {label}
  </span>
);

export const Categories = () => {
  return (
    <section id="categories" className="scroll-mt-20 overflow-hidden bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8">
        <Reveal>
          <Overline>Ce que tu peux déposer</Overline>
          <h2 className="mx-auto mt-5 max-w-3xl font-display text-3xl font-extrabold tracking-tight text-ink sm:text-4xl lg:text-[2.75rem] lg:leading-[1.1]">
            Ton client a besoin de quelque chose que tu ne vends pas&nbsp;?
          </h2>
        </Reveal>
      </div>

      {/* marquee */}
      <div data-testid="deposit-categories-marquee" className="relative mt-14 flex flex-col gap-4">
        <div className="relative flex overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_12%,black_88%,transparent)]">
          <div className="flex animate-marquee whitespace-nowrap py-1">
            {[...CATS, ...CATS].map((c, i) => <Pill key={`a${i}`} label={c} />)}
          </div>
        </div>
        <div className="relative flex overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_12%,black_88%,transparent)]">
          <div className="flex animate-marquee-rev whitespace-nowrap py-1">
            {[...CATS.slice().reverse(), ...CATS.slice().reverse()].map((c, i) => <Pill key={`b${i}`} label={c} />)}
          </div>
        </div>
      </div>

      <Reveal delay={0.1} className="mx-auto mt-12 max-w-7xl px-4 text-center sm:px-6 lg:px-8">
        <p className="text-xl font-bold text-ink sm:text-2xl">
          Et <span className="text-brand">bien plus encore.</span>
        </p>
      </Reveal>
    </section>
  );
};
